import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PageComponent} from "../../../../core/shared/mvs-page/page.component";
import {MvsCoreService} from "../../../../core/shared/service/mvs-core.service";
import {LaunchpadRegistryService} from "../../service/launchpad-registry.service";

/**
 * Generic launchpad page.
 * Reads the moduleAlias from the route and renders the LaunchpadBaseComponent.
 */
@Component({
    selector: 'mvs-launchpad-page',
    templateUrl: './launchpad.page.html',
    standalone: false
})
export class LpLaunchpadPage extends PageComponent implements OnInit, OnChanges, OnDestroy {

    defaultLabel: string = "Launchpad";
    moduleAlias: string;

    constructor(
        protected override route: ActivatedRoute,
        protected override coreService: MvsCoreService,
        private registryService: LaunchpadRegistryService
    ) {
        super(route, coreService);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent(): void {
        this.moduleAlias = this.route.snapshot.paramMap.get('moduleAlias');
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {
    }
}
